import React, { createContext, useMemo, useReducer } from "react";
import { initialState, reducer } from "./reducer";
export const ModalContext = createContext();
export const ModalProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const modalState = useMemo(() => ({ state, dispatch }), [state, dispatch]);
  return /* @__PURE__ */ React.createElement(ModalContext.Provider, { value: modalState }, children);
};
